/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2025, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { Component, Inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpClient } from '@angular/common/http';
import { ButtonSize, ButtonStyle } from '../../aero/aero-button/aero-button.component';

/**
 * Component which handles the getting started templates dialog.
 */
@Component({
  moduleId: module.id,
  selector: 'getting-started-templates-dialog',
  templateUrl: './getting-started-templates-dialog.component.html',
  standalone: false,
})
export class GettingStartedTemplatesDialogComponent {

  public cancelStyle: ButtonStyle = ButtonStyle.GREY;

  public confirmStyle: ButtonStyle = ButtonStyle.SAVE;

  public buttonSize: ButtonSize = ButtonSize.LARGER;

  public dialogAsset: string;

  /**
   * Default Constructor.
   *
   * @param dialogRef Reference to the open dialog.
   * @param dynamicConfig Dialog configuration.
   * @param http Http client.
   * @param BulbAuthService for finding and updating current user.
   * @param BulbErrorService for handling errors.
   * @param state
   */
  constructor(
    public dialogRef : DynamicDialogRef,
    public dynamicConfig: DynamicDialogConfig,
    private http: HttpClient,
    @Inject('BulbAuthService') private BulbAuthService: any,
    @Inject('BulbErrorService') private BulbErrorService: any,
    @Inject('$state') private state,
  ) {
    const { position } = dynamicConfig;
    if (position === 'EDUCATOR' || position === 'ADMINISTRATOR') {
      this.dialogAsset = 'resources/images/modal-images/educatorsketch.gif';
    } else if (position === 'STUDENT') {
      this.dialogAsset = 'resources/images/modal-images/studentsketch.gif';
    } else {
      this.dialogAsset = 'resources/images/modal-images/professionalsketch.gif';
    }
  }

  /**
   * The GET call to use the getting started templates.
   */
  async useGettingStartedTemplates(copyTemplates): Promise<void> {
    if (copyTemplates) {
      await this.http.post('units/copyStartingTemplates', { copyTemplates }).toPromise();
      await this.BulbAuthService.fetchCurrentUser();
    } else {
      this.BulbAuthService.currentUser.prefs.onBoarding.onboardingShowStartingTemplates = false;
      this.BulbAuthService.currentUser.prefs.onBoarding.useStartingTemplates = false;
      await this.http.post('units/skipCopyTemplate', {}).toPromise();
    }
    this.continue();
  }

  /**
   * Used to properly close the dialog in angular js.
   */
  continue() : void {
    this.dialogRef.close();
    // @ts-ignore
    if (this.dynamicConfig.runningInAngularJS) {
      /*
      Important Note:
      This is needed to remove primengs dynamic dialog from the DOM. For some reason, the component that
      registers the initial opening of the dialog can't seem to close it. This only happens in our AngularJS
      framework.
      */
      // @ts-ignore
      jQuery('p-dynamicdialog').remove();
    }
  }
}
